import { frontendURL } from '../../../helper/URLHelper';

const KanbanDashboard = () => import('./KanbanDashboard.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban/pipelines/:pipelineId'),
    name: 'kanban_pipeline',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: KanbanDashboard,
  },
];
